// Official WhatsApp logo SVG icon
export default function WhatsAppIcon({ className = "w-4 h-4", color = "#25D366" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        fill={color}
        d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977.873 2.78 1.025 2.035 2.788 3.853 4.84 4.864.616.302 2.679 1.106 3.345 1.106.688 0 1.819-.473 2.05-.989.115-.273.215-.561.215-.86 0-.215-.058-.327-.144-.42-.245-.21-1.92-1.13-2.16-1.218l-.71-.215Z"
      />
      <path
        fill={color}
        d="M16.029 0C7.265 0 .126 7.054.126 15.713c0 2.764.733 5.46 2.114 7.838L0 32l8.717-2.273a16.066 16.066 0 0 0 7.312 1.768c8.764 0 15.903-7.054 15.903-15.713S24.793 0 16.029 0Zm0 28.842c-2.479 0-4.876-.66-6.987-1.91l-.502-.297-5.205 1.357 1.392-5.04-.328-.516a13.063 13.063 0 0 1-2.026-7.013c0-7.226 5.961-13.115 13.288-13.115S29.317 8.197 29.317 15.423s-5.96 13.115-13.288 13.115Z"
      />
    </svg>
  );
}
